// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ojstTiyaT0YDtn {
  overflow: visible;
}
.ojstTiyaT0YDtn.MCprYCHqWwChWa {
  width: 584px;
  margin: 0 auto;
  transition: width 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .ojstTiyaT0YDtn.MCprYCHqWwChWa {
    transition: none;
  }
}
.ojstTiyaT0YDtn.MCprYCHqWwChWa.vNBrKReKVp6F4Q {
  width: 1034px;
}
@media only screen and (min-width: 601px) and (max-width: 1049px) {
  .ojstTiyaT0YDtn.MCprYCHqWwChWa.vNBrKReKVp6F4Q {
    width: calc(100vw - 16px);
  }
}
@media only screen and (max-width: 600px) {
  .ojstTiyaT0YDtn.MCprYCHqWwChWa,
  .ojstTiyaT0YDtn.MCprYCHqWwChWa.vNBrKReKVp6F4Q {
    width: calc(100vw - 16px);
    margin: 8px;
  }
}
@media only screen and (max-width: 750px) {
  .ojstTiyaT0YDtn > div {
    /* stylelint-disable-next-line declaration-no-important */
    margin: 0 !important;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBackDialog": `ojstTiyaT0YDtn`,
	"cardBackRedesign": `MCprYCHqWwChWa`,
	"withPanel": `vNBrKReKVp6F4Q`
};
export default ___CSS_LOADER_EXPORT___;
